import React from 'react';
import PropTypes from 'prop-types';

import { H2, Link } from '../../../../../../../components/Typography';
import PaymentMethodList from '../../../AddPaymentMethods/PaymentMethodList';

import styles from './ChoosePaymentOption.module.scss';

const ChoosePaymentOption = ({ title, onSelection, onManualBankOption }) => {
  return (
    <>
      <H2 className={styles.modalTitle}>{title || 'New Payment Method'}</H2>
      <div className={styles.pmOptions}>
        <div className={styles.pmList}>
          <PaymentMethodList
            handleChangePaymentMethod={onSelection}
            primaryButton
          />
        </div>
        <div className={styles.manuallyEnter}>
          <Link onClick={onManualBankOption} size="normal">
            Enter bank information manually
          </Link>
        </div>
      </div>
    </>
  );
};

ChoosePaymentOption.propTypes = {
  title: PropTypes.string,
  onSelection: PropTypes.func.isRequired,
  onManualBankOption: PropTypes.func.isRequired,
};

export default ChoosePaymentOption;
